module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-MediumItalic.803e1fe8.woff";